import { useSession } from './session';

/**
 * How an environment's name reads: the four names of before D48 in full
 * (prod → Production), from /enums; a free name (prod-eu, demo-client) as written.
 */
export function useEnvironmentName(): (name: string) => string {
  const { enums } = useSession();
  return name => enums.environments.find(e => e.value === name)?.label ?? name;
}

/**
 * A name as the catalogue accepts it, while it is typed: lower case, no accent, any other
 * character becomes a dash (« Recette 2 » → recette-2). A dash at the end stays while typing
 * (prod-…); `finished` drops it.
 */
export function asName(value: string, max: number, finished = false): string {
  const name = value
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+/, '')
    .slice(0, max);
  return finished ? name.replace(/-+$/, '') : name;
}

/** An environment's name the catalogue accepts (as backend-common's ENVIRONMENT_NAME_PATTERN). */
export const isEnvironmentName = (name: string) => /^(?=.{2,30}$)[a-z0-9]+(-[a-z0-9]+)*$/.test(name);

/** SPEC-034 § 12.4: the installation states of a deployment being retired or retired (no server runs it any more). */
export const RETIRED_STATES: string[] = ['retire_requested', 'retiring', 'unlinking', 'retired', 'purging', 'resetting', 'purged'];
